/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBadgeId = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M15 2v2h4v18H5V4h4V2zM9 6H7v14h2v-4h6v4h2V6h-2v2H9zm4 12h-2v2h2zm2-7v2H9v-2zm-2-7h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBadgeId as BadgeId };
